import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              热点爆料
            </h2>
            <p className="text-foreground-500 text-sm">为什么千万吃瓜用户选择91吃瓜</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuresData.map((feature, idx) => (
            <div
              key={feature.id}
              className={`bg-background-50 rounded-2xl p-6 md:p-7 hover:translate-y-[-2px] transition-transform duration-300 ${
                idx >= 3 ? 'lg:col-span-1' : ''
              }`}
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}